import { FormOption } from '../../../../../../../../types/Form';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useAnswerOptions from './useAnswerOptions';
import useEntityOptions from './useEntityOptions';
import useTargetQuestion from './useTargetQuestion';

const useEnumOptions = (
  question: FlowsQuestion,
  field?: string,
): FormOption[] => {
  const targetQuestion = useTargetQuestion(question);

  if (targetQuestion) {
    if (targetQuestion?.rules.input_type === 'TABLE') {
      return useEntityOptions(targetQuestion);
    }

    return useAnswerOptions(targetQuestion, field);
  }

  return [];
};

export default useEnumOptions;
